import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshBranchService {

  private refreshSubject = new Subject<any>();

  refresh$ = this.refreshSubject.asObservable();

  emitRefresh(id: number): void {
    this.refreshSubject.next(id);
  }
}
